/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LoginDto } from '../models/LoginDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LoginControllerService {
    /**
     * @returns LoginDto OK
     * @throws ApiError
     */
    public static tfaVerifyLogin({
        code,
    }: {
        code: string,
    }): CancelablePromise<LoginDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/tfa_verify_login',
            query: {
                'code': code,
            },
        });
    }
}
